export enum DateRangeKey {
    StartDate = "startDate",
    EndDate = "endDate"
}